import { Component, ViewChild, AfterViewInit,Output,EventEmitter } from '@angular/core';
import { AlertService } from '../../_services/alert.service';
import { LoginComponent } from "../login/login";
import { AuthenticationService } from "../../_services/authentication.service";
import { SettingsService } from "../../_services/settings.service";


@Component({
    selector: 'header',
    providers: [],
    templateUrl: 'header.html'
})

export class HeaderComponent
{
    content = "Hello Header";
    params: any[] = [];
    showDets = false;
    editProfile = false;
    pageSettings = this.settings.pageSettings;

    @Output()
    loggedin: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(public auth: AuthenticationService,public alert:AlertService, public settings:SettingsService) {
        this.urlVars();
        this.tryLocal();
    }
    fauxalert() {
      this.alert.error("Houston, we have a problem");
    }
    tryLocal() {
      var current = localStorage.getItem("currentUser");
      if (current) {
        this.auth.user = JSON.parse(current);
        if (!this.auth.user.firstName || this.auth.user.firstName == "") this.auth.user.firstName = "Xavier";
        this.auth.userInfo().subscribe(data => {
          //access token still valid;
          this.auth.user.loggedin = true;
          this.loggedin.emit(true);
        }, error => {
          this.auth.login(this.auth.user.email, this.auth.user.password).subscribe(data => {
            this.auth.user.token = data['access_token'];
            this.auth.user.loggedin = true;
            localStorage.setItem("currentUser", JSON.stringify(this.auth.user));
            this.loggedin.emit(true);
          }, error => {
            this.auth.user.loggedin = false;
            this.auth.loginHelper.present = true;

          })
        });
      }
      else {
        this.showLogin();
      }
    }
    showLogin() {
        this.auth.loginHelper.present = true;
    }
    logout() {
        this.auth.logout();
        this.showDets = false;
    }
    showProfile() {
        this.showDets = !this.showDets;
        if (!this.showDets) {
            this.editProfile = false;
        }
    }

    ngAfterViewInit() {
        let scope = this;
        if (scope.params.length > 0) {
            setTimeout(function () { scope.checkConfirm(scope);scope.checkReset() });
        }
    }
    checkConfirm(scope:any) {
        this.params.some(function (param) {
            if (param.key == 'confirm'){
                if (param.value == 'True') {
                    scope.alert.success("Email Confirmed, thanks");
                    return true;
                }
                else {
                    scope.alert.error("Email Confirmation failed, please try again");
                    return true;
                }
            }
        })
    }
    checkReset() {
        let code = "";
        let userid = "";
        this.params.some(function (param) {
            if (param.key == 'userId') {
                userid = param.value;
            }
            if (param.key == 'code') {
                code = param.value;
            }
            if (code != "" && userid != "") {
                return true;
            }
        });
        if (code != "" && userid != "") {
            this.alert.success("Please provide a new password");
            this.auth.user.id = userid;
            this.auth.user.token = code;
            this.auth.loginHelper.reset = true;
        }
        else {
            this.alert.error("Password reset failed, please try again");
            this.auth.loginHelper.attempts = 2;
            this.auth.loginHelper.reset = false;
            this.auth.loginHelper.present = true;
        }
    }
    new() {
      this.showDets = false;
      this.auth.loginHelper.present = true;
      this.auth.loginHelper.isRegister = true;
      
    }
    edit() {
        this.auth.user.newPassword = "";
        this.auth.user.confirmPassword = "";
        this.editProfile = true;
    }
    updateProfile() {
        this.auth.updateProfile().subscribe((data) => {
          let errors:string[] = data['errors'];
          if (errors && errors.length > 0) {
                let messagecount = errors.length;
                let currentcount = 0;
                let messages = "Update Failed: ";
                errors.forEach((message) => {
                    currentcount++;
                    messages += message;
                    if (currentcount < messagecount) {
                        messages += ", ";
                    }

                });
                this.alert.error(messages);
            }
            else {
                this.alert.success("Profile updated");
                localStorage.setItem("currentUser", JSON.stringify(this.auth.user));
                this.editProfile = false;
            }
            this.auth.user.oldPassword = "";
        }, error => {
            this.alert.error(error);
        });
    }
    urlVars() {
        let url = location.search;
        let index = url.indexOf('?');
        if (index == 0) {
            let paramstring = url.substring(index + 1);
            let paramall = paramstring.split('&');
            let scope = this;
            paramall.forEach(function (param) {
                let value = param.split('=');
                let entry = { key: value[0], value: value[1] };
                scope.params.push(entry);
            })
        }

    }
    bubbleup(logsuccess:boolean) {
      if (logsuccess) {
        this.loggedin.emit(true);
      }
    }
}



// WEBPACK FOOTER //
// E:/Release/InzuzoA/InzuzoA/src/app/components/header/header.ts